import { globalConstants, companyConstants } from "../../constants";

//Destructuring global constants
const { SUCCESS } = globalConstants;

//Default state of admin reducer
const initialState = {
  data: [],
  allData: [],
  formData: {},
};
//Manipulating the state of admin portal based on actions and returning the state
export const companyReducer = (state = initialState, action) => {
  switch (action.type) {
    case companyConstants.GET_COMPANY + SUCCESS:
      return { ...state, data: action.data };
    case companyConstants.GET_COMPANY_LIST + SUCCESS:
      return { ...state, allData: action.data?.items };
    case companyConstants.GET_COMPANY_BY_ID + SUCCESS:
      return { ...state, formData: action.data };
    default:
      return state;
  }
};
